// Configuration for all send pages
export const SEND_CONFIGS = {
  campaign: {
    itemName: "campaign",
    itemLabel: "Campaign ID",
    itemIdField: "campaignid",
    itemDisplayField: "campaignname",
    itemApiUrl: "https://api.dqr-display-tms.bonrix.in/api/CampaignOperation/GetDistinct/campaignname_active",
    singleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/Campaign",
    groupApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SG/Campaign",
    singleTitle: "Send Campaign",
    groupTitle: "Send Campaign to SubGroup",
    singleButtonText: "Send Campaign",
    groupButtonText: "Send Campaign to SubGroup",
  },
  audio: {
    itemName: "audio",
    itemLabel: "Audio ID",
    itemIdField: "audioid",
    itemDisplayField: "audioname",
    itemApiUrl: "https://api.dqr-display-tms.bonrix.in/api/AudioOperation/GetDistinct/name_active",
    singleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/Audio",
    groupApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SG/Audio",
    singleTitle: "Send Audio",
    groupTitle: "Send Audio to SubGroup",
    singleButtonText: "Send Audio",
    groupButtonText: "Send Audio to SubGroup",
  },
  audioPackage: {
    itemName: "audio package",
    itemLabel: "Audio Package ID",
    itemIdField: "audiopackageid",
    itemDisplayField: "audiopackagename",
    itemApiUrl: "https://api.dqr-display-tms.bonrix.in/api/AudioPackOperation/GetDistinct/name_active",
    singleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/AudioPackage",
    groupApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SG/AudioPackage",
    singleTitle: "Send Audio Package",
    groupTitle: "Send Audio Package to SubGroup",
    singleButtonText: "Send Audio Package",
    groupButtonText: "Send Audio Package to SubGroup",
  },
  catalog: {
    itemName: "catalog",
    itemLabel: "Catalog ID",
    itemIdField: "catalogid",
    itemDisplayField: "catalogname",
    itemApiUrl: "https://api.dqr-display-tms.bonrix.in/api/CatalogOperation/GetDistinct/catalogname_active",
    singleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/Catalog",
    groupApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SG/Catalog",
    singleTitle: "Send Catalogue",
    groupTitle: "Send Catalogue to SubGroup",
    singleButtonText: "Send Catalogue",
    groupButtonText: "Send Catalogue to SubGroup",
    deleteApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/Delete/Catalog",
    deleteAllApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/DeleteAll/Catalog",
    groupDeleteApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SG/Delete/Catalog",
    groupDeleteAllApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SG/DeleteAll/Catalog",
  },
  schedule: {
    itemName: "schedule",
    itemLabel: "Schedule ID",
    itemIdField: "schedulerid",
    itemDisplayField: "schedulername",
    itemApiUrl: "https://api.dqr-display-tms.bonrix.in/api/CatalogSchedulerOperation/GetDistinct/name_active",
    singleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/CatalogScheduler",
    groupApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SG/CatalogScheduler",
    singleTitle: "Send Schedule",
    groupTitle: "Send Schedule to SubGroup",
    singleButtonText: "Send Schedule",
    groupButtonText: "Send Schedule to SubGroup",
  },
  firmware: {
    itemName: "firmware",
    itemLabel: "Firmware ID",
    itemIdField: "Firmwareid",
    itemDisplayField: "firmwarename",
    itemApiUrl: "https://api.dqr-display-tms.bonrix.in/api/FirmwareOperation/GetDistinct/name_active",
    singleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/Firmware",
    groupApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SG/Firmware",
    singleTitle: "Send Firmware",
    groupTitle: "Send Firmware to SubGroup",
    singleButtonText: "Send Firmware",
    groupButtonText: "Send Firmware to SubGroup",
  },
  htmlDoc: {
    itemName: "htmldoc",
    itemLabel: "HTML Doc ID",
    itemIdField: "htmldocid",
    itemDisplayField: "name",
    itemApiUrl: "https://api.dqr-display-tms.bonrix.in/api/HtmlDocOperation/GetDistinct/name_active",
    singleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/HtmlDoc",
    groupApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SG/HtmlDoc",
    singleTitle: "Send HTML Doc",
    groupTitle: "Send HTML Doc to SubGroup",
    singleButtonText: "Send HTML Doc",
    groupButtonText: "Send HTML Doc to SubGroup",
  },
  htmlDocZip: {
    itemName: "htmldoczip",
    itemLabel: "HTML Doc Zip ID",
    itemIdField: "htmldoczipid",
    itemDisplayField: "name",
    itemApiUrl: "https://api.dqr-display-tms.bonrix.in/api/HtmlDocZipOperation/GetDistinct/name_active",
    singleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/HtmlDocZip",
    groupApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SG/HtmlDocZip",
    singleTitle: "Send HTML Doc Zip",
    groupTitle: "Send HTML Doc Zip to SubGroup",
    singleButtonText: "Send HTML Doc Zip",
    groupButtonText: "Send HTML Doc Zip to SubGroup",
  },
  dqrImage: {
    itemName: "dqr image",
    itemLabel: "DQR Image ID",
    itemIdField: "dqrimageid",
    itemDisplayField: "imagename",
    itemApiUrl: "https://api.dqr-display-tms.bonrix.in/api/DQROperation/GetDistinct/dqrname_active",
    singleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/DqrImage",
    groupApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SG/DqrImage",
    singleTitle: "Send DQR Image",
    groupTitle: "Send DQR Image to SubGroup",
    singleButtonText: "Send DQR Image",
    groupButtonText: "Send DQR Image to SubGroup",
  },
  awsIotCore: {
    itemName: "AWS IoT Core",
    itemLabel: "AWS IoT Core ID",
    itemIdField: "awsiotcoreid",
    itemDisplayField: "topicname",
    itemApiUrl: "https://api.dqr-display-tms.bonrix.in/api/AWSIOTCore",
    singleApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/AWSIOTCore",
    groupApiUrl: "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SG/AWSIOTCore",
    singleTitle: "Send AWS IoT Core",
    groupTitle: "Send AWS IoT Core to SubGroup",
    singleButtonText: "Send AWS IoT Core",
    groupButtonText: "Send AWS IoT Core to SubGroup",
  },
};

// Helper function to get config by type
export const getSendConfig = (type) => {
  return SEND_CONFIGS[type];
};
